import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import * as Yup from "yup";
import axios from "../../../services/index.service";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import {
  fetchDocumentInstructions,
  getDocumentProcessingFee,
} from "../../../actions/document.action";
import { fetchDeliveryStations } from "../../../actions/delivery.action";
import DocButtomButton from "../../../components/DocButtomButton";
import TopNav from "../../../components/TopNav";
import DocumentSubmissionType from "../components/docprocessing/DocumentSubmissionType";
import DocumentDeliveryType from "../components/docprocessing/DocumentDeliveryType";
import DropDownInput from "../../../components/DropDownInput";
import ErrorInputComponent from "../../../components/ErrorInputComponent";
import BounceLoader from "../../../components/loader/BounceLoader";
import { Loading } from "../../../utils/helpers/constants";
import { fetchDeliveryFees } from "../../../actions/delivery.action";
import "../doc_processing.css";
import TokenHelpers from "../../../utils/helpers/tokenHelper";
import { getAccountPathByName } from "../../../utils/helpers/getAccountTypeName";

export default function CertProcessing() {
  const dispatch = useDispatch();
  const history = useHistory();
  const [alumniFee, setAlumniFee] = useState(0);
  const [documentFee, setDocumentFee] = useState(0);
  const [documentFormat, setDocumentFormat] = useState("HARD_COPY");

  const account_type = TokenHelpers.getFromStorage("account_type");
  const account_path = getAccountPathByName(account_type);

  useEffect(() => {
    dispatch(fetchDocumentInstructions("CERTIFICATE_PROCESSING"));
    getAlumniFee("ALUMNI_FEE", "SOFT_COPY");
    getDocumentFee("CERTIFICATE_PROCESSING", "SOFT_COPY");
    dispatch(fetchDeliveryFees());
  }, []);

  const {
    documentInstruction: {
      instructions,
      processingFeeLoading,
      instructionLoading,
      countryLoading,
    },
  } = useSelector(({ documentReducer }) => ({
    documentInstruction: documentReducer,
  }));

  const {
    delivery: { deliveryFeeList, deliveryFeeLoading },
  } = useSelector(({ deliveryFeeReducer }) => ({
    delivery: deliveryFeeReducer,
  }));

  const validationSchema = Yup.object({
    documentFormat: Yup.string(),
    misplacedDocument: Yup.boolean(),
    submissionType: Yup.string(),
    pickUpLocation: Yup.string().when("deliveryType", {
      is: "PICK_UP",
      then: Yup.string().required("Pickup address is required"),
    }),
    pickUpLogistic: Yup.string().when("deliveryType", {
      is: "PICK_UP",
      then: Yup.string().required("Pickup logistic is required"),
    }),
    pickUpCity: Yup.string().when("deliveryType", {
      is: "PICK_UP",
      then: Yup.string().required("Pickup city is required"),
    }),
    dropOffLocation: Yup.string().when("submissionType", {
      is: "DISPATCH",
      then: Yup.string().required("Delivery address is required"),
    }),
    dropOffLogistic: Yup.string().when("submissionType", {
      is: "DISPATCH",
      then: Yup.string().required("Delivery logistic is required"),
    }),
    dropOffCity: Yup.string().when("submissionType", {
      is: "DISPATCH",
      then: Yup.string().required("Delivery city is required"),
    }),
  });

  const { handleSubmit, handleChange, values, errors } = useFormik({
    initialValues: {
      misplacedDocument: false,
      documentFormat: "HARD_COPY",
      deliveryType: "PICK_UP",
      documentType: "CERTIFICATE_PROCESSING",
      address: "",
      deliveryPartner: "GIG",
      country: "NGA",
      submissionType: "DISPATCH",
      dropOffLogistic: "GIG",
      dropOffCity: "",
      dropOffLocation: "",
      pickUpLogistic: "GIG",
      pickUpCity: "",
      pickUpLocation: "",
    },
    validationSchema,
    onSubmit(values) {
      const softCopyPayload = {
        documentFormat: documentFormat,
        documentType: "CERTIFICATE_PROCESSING",
      };

      const hardCopyPayload = {
        deliveryType: values.deliveryType,
        submissionType: values.submissionType,
        misplacedDocument: values.misplacedDocument,
        documentFormat: documentFormat,
        dropOffAddress:
          values.submissionType === "DISPATCH"
            ? {
                deliveryPartner: values.dropOffLogistic,
                city: values.dropOffCity,
                locationAddress: values.dropOffLocation,
              }
            : null,
        pickUpAddress:
          values.deliveryType === "PICK_UP"
            ? {
                deliveryPartner: values.pickUpLogistic,
                city: values.pickUpCity,
                locationAddress: values.pickUpLocation,
              }
            : null,
        documentType: "CERTIFICATE_PROCESSING",
      };

      const payload =
        documentFormat === "SOFT_COPY" ? softCopyPayload : hardCopyPayload;
      const navigateLink = () =>
        history.push({
          state: payload,
          pathname: `/dashboard${account_path}document-processing/payment`,
        });
      dispatch(getDocumentProcessingFee(payload, navigateLink));
    },
  });

  const getAlumniFee = (feeType, format) => {
    axios.get(`/api/services/v1/fees/type/${feeType}/${format}`).then((res) => {
      if (res?.data !== undefined) {
        if (Object.keys(res?.data).length) {
          setAlumniFee(res.data.fee);
        }
      }
    });
  };

  const getDocumentFee = (feeType, format) => {
    axios.get(`/api/services/v1/fees/type/${feeType}/${format}`).then((res) => {
      if (res?.data !== undefined) {
        if (Object.keys(res?.data).length) {
          console.log("res.data.fee ", res.data.fee);
          setDocumentFee(res.data.fee);
        }
      }
    });
  };

  const logisticCompanies = [{ value: "GIG", name: "GIG" }];
  const loadState =
    deliveryFeeLoading ||
    processingFeeLoading === Loading.FETCHING ||
    countryLoading === Loading.FETCHING;

  const InstructionComponent = ({ instruction }) => {
    return (
      <li>
        {instruction?.instruction}
        <span className="font-bold">
          {instruction?.costType === "ALUMNI_FEE" ? " N" + alumniFee : null}
          {instruction?.costType === "TRANSCRIPT_OFFICIAL"
            ? " N" + documentFee
            : null}
        </span>
      </li>
    );
  };

  return (
    <div>
      <div>
        <>
          <div className="overflow-hidden">
            <div className=" doc_processing_color h-44 px-2 pt-3">
              <TopNav />
              <div className="transcript_header">Certificate Processing</div>
              <div className="text-lg md:w-2/3">
                Get your certificate and other necessary documents easily and
                fast
              </div>
            </div>
            <div className="p-2">
              {instructionLoading ? (
                <div className="center_container">
                  <BounceLoader />
                </div>
              ) : (
                <div>
                  <div className="px-2 md:mx-20 mt-2 md:mt-10">
                    <p className="font-semibold text-lg">Requirements:</p>
                    <div className="px-4">
                      <ul className="space-y-1 max-w-md list-disc list-inside">
                        {instructions.map((instruction, index) => {
                          return (
                            <InstructionComponent
                              instruction={instruction}
                              key={index}
                            />
                          );
                        })}
                      </ul>
                    </div>
                    <p className="my-5">
                      How would you like to receive your certificate?
                    </p>
                  </div>

                  <div className="md:flex md:flex-column md:justify-center">
                    <div className="px-2 md:w-1/2 mt-0">
                      <form className="p-0">
                        <div className="flex items-center my-5">
                          <input
                            id="link-checkbox"
                            type="checkbox"
                            name="misplacedDocument"
                            onChange={handleChange}
                            className="checkbox-square mr-3 leading-tight focus:ring-green-500"
                          />
                          <label
                            htmlFor="link-checkbox"
                            className="ml-1 text-sm font-medium text-gray-900 dark:text-gray-300"
                          >
                            Misplaced Documents
                            <br />
                            Have you misplaced any of your documents(ID Card,
                            Certificate, Notification of Result)? Go to your
                            profile to upload a police report and a court
                            affidavit of the lost document.
                          </label>
                        </div>
                        <section className="mt-5">
                          <div>
                            <div className="font-bold text-l">
                              Document Submission
                            </div>
                            <DocumentSubmissionType
                              name={"deliveryType"}
                              handleChange={handleChange}
                            />
                            {values.deliveryType === "PICK_UP" && (
                              <>
                                <div className="flex mt-3 gap-2">
                                  <div className="w-full">
                                    <DropDownInput
                                      list={logisticCompanies}
                                      name="pickUpLogistic"
                                      handleChange={handleChange}
                                      defaultValue="GIG"
                                      placeholder={"logistics company"}
                                    />
                                    <ErrorInputComponent
                                      error={errors.pickUpLogistic}
                                    />
                                  </div>

                                  <div className="w-full">
                                    <DropDownInput
                                      list={deliveryFeeList}
                                      name="pickUpCity"
                                      handleChange={handleChange}
                                      defaultValue="LAGOS"
                                      placeholder={"station"}
                                    />
                                    <ErrorInputComponent
                                      error={errors.pickUpCity}
                                    />
                                  </div>
                                </div>

                                <div className="flex flex-col">
                                  <input
                                    className="mb-3 appearance-none border border-gray-400 rounded w-full pt-4 pb-4 py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-green-800"
                                    id="inline-full-name"
                                    type="location"
                                    name="pickUpLocation"
                                    onChange={handleChange}
                                    placeholder="Location"
                                  />
                                  <ErrorInputComponent
                                    error={errors.pickUpLocation}
                                  />
                                </div>
                              </>
                            )}
                          </div>
                          <div className="mt-5">
                            <div className="font-bold text-l">
                              Document Delivery
                            </div>
                            <DocumentDeliveryType
                              name={"submissionType"}
                              handleChange={handleChange}
                            />
                            {(values.submissionType === "DISPATCH" ||
                              values.submissionType === "PICK_UP") && (
                              <>
                                <div className="flex mt-3 gap-2">
                                  <div className="w-full">
                                    <DropDownInput
                                      list={logisticCompanies}
                                      name="dropOffLogistic"
                                      handleChange={handleChange}
                                      defaultValue="GIG"
                                      placeholder={"logistics company"}
                                    />
                                    <ErrorInputComponent
                                      error={errors.dropOffLogistic}
                                    />
                                  </div>
                                  <div className="w-full">
                                    <DropDownInput
                                      list={deliveryFeeList}
                                      name="dropOffCity"
                                      handleChange={handleChange}
                                      defaultValue="LAGOS"
                                      placeholder={"station"}
                                    />
                                    <ErrorInputComponent
                                      error={errors.dropOffCity}
                                    />
                                  </div>
                                </div>
                                <div>
                                  <input
                                    className="mb-3 appearance-none border border-gray-400 rounded w-full pt-4 pb-4 py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-green-800"
                                    id="inline-full-name"
                                    type="location"
                                    name="dropOffLocation"
                                    onChange={handleChange}
                                    placeholder="Location"
                                  />
                                  <ErrorInputComponent
                                    error={errors.dropOffLocation}
                                  />
                                </div>
                              </>
                            )}
                          </div>
                        </section>
                      </form>
                      <DocButtomButton
                        name={"Next"}
                        func={handleSubmit}
                        loading={loadState}
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </>
      </div>
    </div>
  );
}
